import { useMemo } from "react";

import type { BlOption } from "Shared/Inputs/BlOption";
import { useActorsQuery } from "./useActorsQuery";

export function useActorOptions(): BlOption[] {
  const { data } = useActorsQuery({ offset: 0, limit: 1000 });

  return useMemo(
    () =>
      (data?.items ?? []).map((actor) => ({
        value: actor.actorID.toString(),
        label: actor.name,
      })),
    [data],
  );
}
